"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cookiesEnabled = cookiesEnabled;
function cookiesEnabled() {
    return navigator.cookiesEnabled;
}